import React from "react";

import {
  Drawer,
  makeStyles,
  Close,
  IconButton,
} from "../../shared/materials/helper";

import ChallanBaseButton from "../../shared/materials/Buttons/ChallanBaseButton";
import ChallanTextInput from "../../shared/materials/Inputs/ChallanTextInput";
import AddUsersAlt from "../../../assests/icons/AddUsersAlt";
import ChallanSelectInput from "../../shared/materials/Inputs/ChallanSelectInput";
import { userRole } from "../../../data/metadata/usersMetaData";

const useStyles = makeStyles((theme) => ({
  container: { width: "50%" },
  drawerContainer: {
    width: "35vw",
    padding: theme.spacing(4),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
  },
  headerText: {
    fontWeight: 700,
    fontSize: 20,
  },
  subHeader: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    margin: theme.spacing(3),
  },
  subheaderText: {
    fontWeight: 600,
    fontSize: 16,
  },
  subheaderSubText: {
    fontWeight: 400,
    fontSize: 12,
    margin: 0,
  },
}));

export default function EditUser({ userInfo, onChange, onUpdate }) {
  const [state, setState] = React.useState(false);
  const classes = useStyles();

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState(open);
  };

  const onSubmitClick = async (event) => {
    const status = await onUpdate();

    if (status) {
      toggleDrawer(false)(event);
    }
  };

  return (
    <div className={classes.container}>
      <Drawer anchor={"right"} open={state} onClose={toggleDrawer(false)}>
        <div className={classes.drawerContainer}>
          <div className={classes.header}>
            <h1 className={classes.headerText}>Edit User</h1>
            <IconButton
              onClick={toggleDrawer(false)}
              sx={{ width: 48, height: 48 }}
            >
              <Close />
            </IconButton>
          </div>
          <div className={classes.subHeader}>
            <AddUsersAlt />
            <p className={classes.subheaderText}>
              Update existing user information
            </p>
            <p className={classes.subheaderSubText}>
              Update users as a viewer or an admin
            </p>
          </div>
          {/* <form onSubmit={onSubmitClick}> */}
          <ChallanTextInput
            id="first-name"
            label="Name"
            placeholder={"Name of the user..."}
            onChange={onChange("name")}
            value={userInfo.name}
          />
          <ChallanSelectInput
            id="userrole-create"
            label="User Role"
            placeholder={"Role of the user..."}
            onChange={onChange("grant_type")}
            value={userInfo.grant_type}
            options={userRole}
            inputProps={{
              autoComplete: "off",
            }}
          />
          <ChallanTextInput
            id="association-create"
            label="User Association"
            placeholder={"Association of the user..."}
            onChange={onChange("association")}
            value={userInfo.association}
            inputProps={{
              autoComplete: "off",
            }}
          />
          <ChallanTextInput
            id="phone-create"
            label="Mobile"
            placeholder={"Mobile no. of the user..."}
            onChange={onChange("phone")}
            value={userInfo.phone}
            inputProps={{
              autoComplete: "off",
            }}
          />
          <ChallanTextInput
            id="email-create"
            label="Email"
            placeholder={"Email of the user..."}
            onChange={onChange("email")}
            value={userInfo.email}
            inputProps={{
              autoComplete: "off",
            }}
          />

          <div
            style={{
              display: "flex",
              justifyContent: "space-around",
              paddingBottom: 16,
              paddingTop: 16,
            }}
          >
            <ChallanBaseButton
              onClick={toggleDrawer(false)}
              text={"Cancel"}
              type={"cancel"}
              width={"48%"}
            />
            <ChallanBaseButton
              onClick={onSubmitClick}
              text={"Apply Changes"}
              type={"ok"}
              width={"48%"}
              //typeOf={"submit"}
            />
          </div>
          {/* </form> */}
        </div>
      </Drawer>
      <ChallanBaseButton
        onClick={toggleDrawer(true)}
        text={"View Details"}
        type={"cancel"}
      />
    </div>
  );
}
